import classnames from 'classnames';
import Button from 'mcs-toolkit/components/Button';
import React from 'react';
import { ButtonProps } from 'semantic-ui-react';

import css from './buttonLink.css';

type Props = ButtonProps & {
    className?: string;
    secondary?: boolean;
    dataTest?: string;
    children: React.ReactNode;
};

export const ButtonLink = ({
    className,
    secondary,
    children,
    color,
    dataTest = 'button-link',
    ...rest
}: Props) => (
    <Button
        data-test={dataTest}
        as="a"
        className={classnames([css.main, className])}
        basic
        {...rest}
    >
        <span
            className={classnames(css.text, {
                [css.secondary]: secondary || rest.disabled,
            })}
        >
            {children}
        </span>
    </Button>
);
export default ButtonLink;
